import { useAuth, useGreeterVenueApi } from "@greeter/matter";
import { TicketScannerPage } from "./TicketScannerPage";
import { useEffect } from "react";

export function TicketScannerPageApiHandler() {
  const { api } = useGreeterVenueApi();
  const auth = useAuth();

  return <TicketScannerPage api={api} />;
}
